module.exports = __webpack_public_path__ + "img/polygon_small.d070d9c2.svg";